import React, { useState, useEffect } from 'react';
import * as api from '../../api/index.js';
import { Form, Button, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';

function UpFormCom({ brandSlug, handlePageChange }) {
  const [brand, setBrand] = useState({});
  const [formData, setFormData] = useState({
    name: '',
  });
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await api.markaGetir(brandSlug);
        setBrand(response.data.brand);
        setFormData({
          name: response.data.brand.name || '',
        });
      } catch (error) {
        console.log(error);
      }
    };
    getBrand();
  }, [brandSlug]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, errors } = validateForm();
    if (!isValid) {
      setFormErrors(errors);
      return;
    }
    try {
      const response = await api.markaGuncelle(brandSlug, formData);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      handlePageChange("markalar");
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;
    if (!formData.name) {
      errors.name = 'Marka adı giriniz';
      isValid = false;
    }
    setFormErrors(errors);
    return { isValid, errors };
  };

  return (
    <div>
      <h5 className='mb-3 text-center'>MARKA GÜNCELLE</h5>
      <Container>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3' controlId='formBasicBrandName'>
            <Form.Label>Marka Adı</Form.Label>
            <Form.Control
              type='text'
              name='name'
              value={formData.name}
              onChange={handleChange}
              placeholder='Marka Adı'
            />
            {formErrors.name && (
              <div className='text-danger'>{formErrors.name}</div>
            )}
          </Form.Group>

          <div className='d-grid gap-2'>
            <Button variant='primary' size='lg' type='submit'>
              Kaydet
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
}

export default UpFormCom;
